import { FormPage } from "app/pages/public/FormPage";
import FacebookCallback from "app/pages/auth/FacebookCallback";

const publicRoutes = {
  id: "public",
  children: [
    {
      path: "/form/:formId",
      Component: FormPage,
    },
    {
      path: "/facebook/callback",
      Component: FacebookCallback,
    },
    {
      path: "/privacy",
      lazy: async () => ({
        Component: (await import("app/pages/legal/Privacy")).default,
      }),
    },
    {
      path: "/terms",
      lazy: async () => ({
        Component: (await import("app/pages/legal/Terms")).default,
      }),
    },
    
  ],
};

export { publicRoutes };
